const getCellValue = (tr, idx) => tr.children[idx].textContent;

function compareNames(a, b) {
  const aSplit = [a.match(/[^0-9.]+/)[0], a.match(/[0-9.]+/)[0]];
  const bSplit = [b.match(/[^0-9.]+/)[0], b.match(/[0-9.]+/)[0]];

  if (aSplit[0] === bSplit[0]) return aSplit[1] - bSplit[1];
  return aSplit[0].localeCompare(bSplit[0]);
}

function comparer(id, isAscending) {
  const compare = (v1, v2) => {
    const v1Number = parseFloat(v1.replaceAll(/[^0-9.]/g, ""));
    const v2Number = parseFloat(v2.replaceAll(/[^0-9.]/g, ""));
    if (v1 !== '' && v2 !== '' && !(isNaN(v1Number) || isNaN(v2Number))) {
      return v1Number - v2Number;
    }
    if (id === 0) return compareNames(v1, v2);
    return v1.toString().localeCompare(v2);
  };

  return (a, b) => compare(
    getCellValue(isAscending ? a : b, id),
    getCellValue(isAscending ? b : a, id)
  );
}

function handleHeaderClick(th) {
  const index = Array.from(th.parentNode.children).indexOf(th);
  if (state.column === index) state.isAscending = !state.isAscending;
  else state.isAscending = true;
  state.column = index;

  headers.forEach(th2 => {
    th2.classList.remove('ascending');
    th2.classList.remove('descending');
  });

  th.classList.add(state.isAscending ? 'ascending' : 'descending');

  Array.from(table.querySelectorAll('tr:nth-child(n+2)'))
    .sort(comparer(index, state.isAscending))
    .forEach(tr => table.appendChild(tr));
}

const table = document.getElementById('apartment-table');
const state = {
  column: undefined,
  isAscending: true,
};
let headers;

if (table !== null) {
  headers = table.querySelectorAll('th');
  headers.forEach(th => th.addEventListener('click', () => handleHeaderClick(th)));
}
